import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { OUTSTANDING_ADVANCES_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportOutstandingAdvances({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: applyExcelFormats(value, OUTSTANDING_ADVANCES_COLUMNS[key]?.style?.numFmt),
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={OUTSTANDING_ADVANCES_COLUMNS}
        headerHeight={36}
        rowKey="advanceId"
      />
    </>
  );
}

export default ReportOutstandingAdvances;
